import { useMutation, useQueryClient } from "react-query";
import { updateOfficeDepartment } from "../../../../../actions/Utilities/OfficeDepartment";

const useEditOfficeDepartment = () => {
  return useMutation(updateOfficeDepartment);
};

export default useEditOfficeDepartment;
